import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
} from 'anf-core-react';

export default function Clickable({
  onClick,
  isClickable = false,
  children,
  testId = 'clickable',
}) {
  if (!isClickable) return children;

  return (
    <Button
      onClick={onClick}
      classList="make-it-clickable"
    >
      <div data-testid={testId} className="clickable-content-wrapper">
        {children}
      </div>
    </Button>
  );
}

Clickable.propTypes = {
  onClick: PropTypes.func.isRequired,
  isClickable: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  testId: PropTypes.string,
};
